import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TVesselCurrentStatus, TVesselCurrentStatusState, VESSEL_CURRENT_STATUS } from "../mapTypes";
import { RootState } from "../../../core/store";

const initialState: TVesselCurrentStatusState = {
    vesselCurrentStatusData: null,
    vesselCurrentStatusLoading: false,
    vesselCurrentStatusError: null
};

const vesselCurrentStatusSlice = createSlice({
    name: VESSEL_CURRENT_STATUS,
    initialState,
    reducers: {
        getVesselCurrentStatusRequestAction: (state: TVesselCurrentStatusState, _: PayloadAction<number>) => {
            state.vesselCurrentStatusLoading = true;
            state.vesselCurrentStatusError = null;
        },
        getVesselCurrentStatusSuccessAction: (
            state: TVesselCurrentStatusState,
            { payload: data }: PayloadAction<TVesselCurrentStatus>,
        ) => {
            state.vesselCurrentStatusLoading = false;
            state.vesselCurrentStatusData = data;
            state.vesselCurrentStatusError = null;
        },
        getVesselCurrentStatusErrorAction: (
            state: TVesselCurrentStatusState,
            { payload: error }: PayloadAction<any>,
        ) => {
            state.vesselCurrentStatusData = null;
            state.vesselCurrentStatusLoading = false;
            state.vesselCurrentStatusError = {
                message: (error.response && error.response.data) || error.message || '',
                name: error.name,
                stack: error.stack,
            };
        },
    },
});

export const { getVesselCurrentStatusRequestAction, getVesselCurrentStatusSuccessAction, getVesselCurrentStatusErrorAction } =
    vesselCurrentStatusSlice.actions;

export default vesselCurrentStatusSlice.reducer;

export const selectVesselCurrentStatus = (state: RootState) => state.vesselCurrentStatusSlice.vesselCurrentStatusData!;
